import React from "react";
import { X, Printer } from "lucide-react";
import vrmLogo from "../assets/VRM.jpeg";

function VerifiedPaymentReceiptModal({ isOpen, onClose, data }) {
  if (!isOpen || !data) return null;

  // Extract / calculate fallback fields from data
  const companyName = data.company || data.companyName || "N/A";
  const purchaserName = data.purchaserName || data.contactPerson || data.name || (typeof companyName === "string" ? companyName.split(" ")[0] : "Customer");
  const emailAddress = data.email || data.companyEmail || "N/A";
  const phone = data.phone || data.contactNumber || "N/A";
  const category = data.product || data.productCategory || "VRM AI Service";
  const plan = data.plan || "Standard Plan";
  const orderId = data.orderId || data.paymentId || (data.transactionId ? String(data.transactionId) : "N/A");
  const txnId = data.transactionId || data.trackingId || data.paymentReference || (orderId !== "N/A" ? orderId : "N/A");
  
  let rawAmount = data.amount !== undefined ? data.amount : (data.totalAmount !== undefined ? data.totalAmount : 0);
  if (typeof rawAmount === "string") {
    rawAmount = parseFloat(rawAmount.replace(/[^0-9.]/g, "")) || 0;
  }
  const formattedAmount = Number(rawAmount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Payment Receipt - ${companyName}</title>
          <style>
            body { font-family: 'Inter', system-ui, sans-serif; background: #f8fafc; margin: 0; padding: 40px 20px; color: #0f172a; }
            .receipt-box { max-width: 540px; margin: 0 auto; background: #ffffff; border-radius: 16px; padding: 32px; border: 1px solid #e2e8f0; box-shadow: 0 10px 30px rgba(0,0,0,0.05); }
            .header { text-align: center; margin-bottom: 20px; }
            .logo-wrap { display: flex; align-items: center; justify-content: center; margin-bottom: 10px; }
            .logo-icon { width: 32px; height: 32px; background: linear-gradient(135deg, #4f46e5, #6366f1); border-radius: 8px; color: #fff; font-weight: 800; display: flex; align-items: center; justify-content: center; font-size: 18px; }
            .title { font-size: 15px; font-weight: 800; color: #0f172a; text-transform: uppercase; letter-spacing: 0.5px; }
            .subtitle { font-size: 11.5px; color: #64748b; margin-top: 2px; }
            .badge-wrap { text-align: center; margin: 16px 0; }
            .badge { display: inline-flex; align-items: center; gap: 6px; padding: 4px 14px; border-radius: 20px; background: #dcfce7; color: #15803d; font-size: 11px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; }
            .amount-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px; text-align: center; margin-bottom: 24px; }
            .amount-label { font-size: 10.5px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; }
            .amount-val { font-size: 28px; font-weight: 800; color: #0f172a; margin-top: 4px; font-family: 'Outfit', sans-serif; }
            .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px 20px; text-align: left; }
            .field-label { font-size: 9.5px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; }
            .field-val { font-size: 12px; font-weight: 700; color: #0f172a; margin-top: 2px; word-break: break-word; }
            .footer-note { border-top: 1px dashed #e2e8f0; margin-top: 24px; padding-top: 16px; font-size: 10px; color: #64748b; text-align: center; line-height: 1.5; }
            @media print { body { background: #fff; padding: 0; } .receipt-box { border: none; box-shadow: none; } }
          </style>
        </head>
        <body>
          <div class="receipt-box">
            <div class="header">
              <div class="logo-wrap">
                <img src="${vrmLogo}" alt="VRM AI Technology Logo" style="display:block;width:170px;height:78px;object-fit:contain;margin:0 auto;" />
              </div>
              <div class="title">VRM AI TECHNOLOGY PRIVATE LIMITED</div>
              <div class="subtitle">Payment Confirmation & Verified Transaction Proof</div>
            </div>

            <div class="badge-wrap">
              <span class="badge">✦ PAYMENT SUCCESSFUL</span>
            </div>

            <div class="amount-card">
              <div class="amount-label">TOTAL AMOUNT PAID</div>
              <div class="amount-val">₹ ${formattedAmount}</div>
            </div>

            <div class="grid">
              <div>
                <div class="field-label">CCAVENUE TRACKING / REF ID</div>
                <div class="field-val" style="color: #4f46e5; font-family: monospace;">${txnId}</div>
              </div>
              <div>
                <div class="field-label">ORDER ID</div>
                <div class="field-val" style="font-family: monospace;">${orderId}</div>
              </div>

              <div>
                <div class="field-label">COMPANY NAME</div>
                <div class="field-val">${companyName}</div>
              </div>
              <div>
                <div class="field-label">PURCHASER NAME</div>
                <div class="field-val">${purchaserName}</div>
              </div>

              <div>
                <div class="field-label">EMAIL ADDRESS</div>
                <div class="field-val">${emailAddress}</div>
              </div>
              <div>
                <div class="field-label">CONTACT NUMBER</div>
                <div class="field-val">${phone}</div>
              </div>

              <div>
                <div class="field-label">PRODUCT CATEGORY</div>
                <div class="field-val">${category}</div>
              </div>
              <div>
                <div class="field-label">PAYMENT GATEWAY</div>
                <div class="field-val">CCAvenue Online PG</div>
              </div>

              <div style="grid-column: span 2;">
                <div class="field-label">PURCHASED DETAILS</div>
                <div class="field-val">${category} - ${plan}</div>
              </div>
            </div>

            <div class="footer-note">
              This is a verified digital transaction proof generated by VRM AI Technology.<br />
              GoodWorks Infinity Park, Electronic City, Bengaluru - 560100
            </div>
          </div>
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="vrm-modal-backdrop" style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(15, 23, 42, 0.65)", backdropFilter: "blur(4px)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div className="vrm-modal-card" style={{ maxWidth: "520px", width: "100%", background: "#ffffff", borderRadius: "20px", padding: "28px", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", border: "1px solid #e2e8f0", boxSizing: "border-box", maxHeight: "90vh", overflowY: "auto" }}>
        
        {/* MODAL CLOSE BUTTON */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "-10px" }}>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", padding: "4px" }}>
            <X size={20} />
          </button>
        </div>

        {/* LOGO & COMPANY TITLE */}
        <div style={{ textAlign: "center", marginBottom: "18px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "8px" }}>
            <img src={vrmLogo} alt="VRM AI Technology Logo" style={{ display: "block", width: "170px", height: "78px", objectFit: "contain", margin: "0 auto" }} />
          </div>
          <div style={{ fontSize: "14px", fontWeight: "800", color: "#0f172a", letterSpacing: "0.02em" }}>
            VRM AI TECHNOLOGY PRIVATE LIMITED
          </div>
          <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>
            Payment Confirmation & Verified Transaction Proof
          </div>
        </div>

        {/* PAYMENT SUCCESSFUL BADGE */}
        <div style={{ textAlign: "center", marginBottom: "18px" }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "5px 16px", borderRadius: "20px", background: "#dcfce7", color: "#15803d", fontSize: "11px", fontWeight: "800", letterSpacing: "0.04em" }}>
            ✦ PAYMENT SUCCESSFUL
          </span>
        </div>

        {/* TOTAL AMOUNT CARD */}
        <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "14px", padding: "16px", textAlign: "center", marginBottom: "22px" }}>
          <div style={{ fontSize: "10.5px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>
            TOTAL AMOUNT PAID
          </div>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: "30px", fontWeight: "800", color: "#0f172a", marginTop: "2px" }}>
            ₹ {formattedAmount}
          </div>
        </div>

        {/* DETAILS GRID */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>CCAVENUE TRACKING / REF ID</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#4f46e5", fontFamily: "monospace", marginTop: "2px" }}>{txnId}</div>
          </div>
          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>ORDER ID</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", fontFamily: "monospace", marginTop: "2px" }}>{orderId}</div>
          </div>

          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>COMPANY NAME</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px" }}>{companyName}</div>
          </div>
          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>PURCHASER NAME</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px" }}>{purchaserName}</div>
          </div>

          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>EMAIL ADDRESS</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px", wordBreak: "break-all" }}>{emailAddress}</div>
          </div>
          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>CONTACT NUMBER</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px" }}>{phone}</div>
          </div>

          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>PRODUCT CATEGORY</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px" }}>{category}</div>
          </div>
          <div>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>PAYMENT GATEWAY</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px" }}>CCAvenue Online PG</div>
          </div>

          <div style={{ gridColumn: "span 2" }}>
            <div style={{ fontSize: "10px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.04em" }}>PURCHASED DETAILS</div>
            <div style={{ fontSize: "12.5px", fontWeight: "700", color: "#0f172a", marginTop: "2px" }}>{category} - {plan}</div>
          </div>
        </div>

        {/* FOOTER NOTE */}
        <div style={{ borderTop: "1px dashed #e2e8f0", paddingTop: "14px", fontSize: "10px", color: "#64748b", textAlign: "center", lineHeight: "1.5", marginBottom: "22px" }}>
          This is a verified digital transaction proof generated by VRM AI Technology.<br />
          GoodWorks Infinity Park, Electronic City, Bengaluru - 560100
        </div>

        {/* ACTION BUTTONS */}
        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <button
            onClick={handlePrint}
            style={{ padding: "10px 20px", borderRadius: "10px", background: "linear-gradient(135deg, #2563eb, #3b82f6)", color: "#ffffff", border: "none", fontSize: "13px", fontWeight: "700", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px", boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)" }}
          >
            <Printer size={15} />
            <span>Print / Save Receipt</span>
          </button>

          <button
            onClick={onClose}
            style={{ padding: "10px 20px", borderRadius: "10px", background: "#f1f5f9", border: "1px solid #cbd5e1", color: "#475569", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
          >
            Close Window
          </button>
        </div>

      </div>
    </div>
  );
}

export default VerifiedPaymentReceiptModal;
